import { darkColors, lightColors } from './defaultTheme.js';
export const COLOR_MODE_STORAGE_KEY = 'fm-color-mode';
const COLOR_TOKEN_MAP = {
    '--fm-color-primary': (c) => c.primary,
    '--fm-color-secondary': (c) => c.secondary,
    '--fm-color-accent': (c) => c.accent,
    '--fm-color-link': (c) => c.link ?? c.accent,
    '--fm-color-bg': (c) => c.background,
    '--fm-color-surface': (c) => c.surface,
    '--fm-color-surface-2': (c) => c.surfaceElevated ?? c.surface,
    '--fm-color-text': (c) => c.text,
    '--fm-color-text-muted': (c) => c.textMuted,
    '--fm-color-border': (c) => c.border,
    '--fm-color-error': (c) => c.error,
    '--fm-color-on-primary': (c) => c.onPrimary,
    '--fm-gradient-brand': (c) => `linear-gradient(180deg, ${c.secondary} 0%, #AD1457 100%)`,
};
function resolvePalette(theme, mode) {
    if (theme?.colorModes?.[mode]) {
        return theme.colorModes[mode];
    }
    return mode === 'dark' ? darkColors : lightColors;
}
function applyColorTokens(colors, target) {
    for (const [token, resolver] of Object.entries(COLOR_TOKEN_MAP)) {
        target.style.setProperty(token, resolver(colors));
    }
}
export function isColorMode(value) {
    return value === 'light' || value === 'dark';
}
/** First visit defaults to light. */
export function getStoredColorMode() {
    if (typeof window === 'undefined') {
        return 'light';
    }
    try {
        const stored = window.localStorage.getItem(COLOR_MODE_STORAGE_KEY);
        return isColorMode(stored) ? stored : 'light';
    }
    catch {
        return 'light';
    }
}
export function persistColorMode(mode) {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        window.localStorage.setItem(COLOR_MODE_STORAGE_KEY, mode);
    }
    catch {
        // Storage may be unavailable (private mode); mode still applies in-session.
    }
}
export function applyColorMode(mode, options) {
    const target = options?.target ?? document.documentElement;
    const colors = resolvePalette(options?.theme, mode);
    applyColorTokens(colors, target);
    target.dataset.colorMode = mode;
    target.style.colorScheme = mode;
    if (typeof document !== 'undefined') {
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) {
            meta.setAttribute('content', mode === 'dark' ? '#0D0D0D' : '#F5F5F5');
        }
    }
    if (options?.persist !== false) {
        persistColorMode(mode);
    }
}
export function applyTheme(theme, target = document.documentElement) {
    target.style.setProperty('--fm-font-heading', theme.fonts.heading);
    target.style.setProperty('--fm-font-body', theme.fonts.body);
    target.style.setProperty('--fm-font-display', theme.fonts.heading);
    target.style.setProperty('--fm-logo-url', `url(${theme.branding.logoUrl})`);
    target.dataset.theme = theme.id;
    const mode = getStoredColorMode();
    applyColorMode(mode, { theme, target, persist: false });
}
//# sourceMappingURL=applyTheme.js.map